module.exports = new __parcel__URL__("gia.cf5fd057.jpg").toString();